import Base from '../../_config/base';

class Header extends Base {
  constructor(el) {
    super(el);
    this.el = el;
    this.body = document.body;

    this.hamburger = el.querySelector('.hamburger');
    this.hamburgerIcon = el.querySelector('#hamburger-icon');

    this.bindMobile();
    this.bindFlyoutHeight();
    this.bindEscape();
    this.bindScrollDirection();
  }

  bindFlyoutHeight() {
    const flyout = document.querySelector('.navigation-flyout');
    const triggers = this.el.querySelectorAll('[data-flyout-trigger]');
    if (!flyout || !triggers.length) return;

    const groups = flyout.querySelectorAll('.navigation-flyout__group');

    const syncHeight = () => {
      const active = flyout.querySelector('.navigation-flyout__group.is-active');
      if (active) flyout.style.height = `${active.scrollHeight}px`;
    };

    const activate = (index) => {
      groups.forEach((g) => g.classList.toggle('is-active', g.dataset.flyout === index));
      syncHeight();
    };

    const setCurrent = (item) => {
      const group = item.closest('.navigation-flyout__group');
      const idx = [...group.querySelectorAll('.navigation-flyout__item')].indexOf(item);
      group.querySelectorAll('.is-current').forEach((el) => el.classList.remove('is-current'));
      item.classList.add('is-current');
      group.querySelectorAll('.navigation-flyout__panel')[idx]?.classList.add('is-current');
    };

    flyout.addEventListener('pointerover', (e) => {
      const item = e.target.closest('.navigation-flyout__item');
      if (item) setCurrent(item);
    });
    flyout.addEventListener('focusin', (e) => {
      const item = e.target.closest('.navigation-flyout__item');
      if (item) setCurrent(item);
    });

    triggers.forEach((trigger) => {
      const onEnter = () => activate(trigger.dataset.flyoutTrigger);
      trigger.addEventListener('mouseenter', onEnter);
      trigger.addEventListener('focusin', onEnter);
    });

    const observer = new ResizeObserver(syncHeight);
    groups.forEach((g) => observer.observe(g));

    const close = (event) => {
      const next = event.relatedTarget;
      if (this.el.contains(next) || flyout.contains(next)) return;
      flyout.style.height = '';
      flyout.querySelectorAll('.is-current').forEach((el) => el.classList.remove('is-current'));
    };
    [this.el, flyout].forEach((el) => {
      el.addEventListener('mouseleave', close);
      el.addEventListener('focusout', close);
    });
  }

  bindMobile() {
    if (!this.hamburger) return;
    this.hamburger.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.hamburgerIcon) this.hamburgerIcon.classList.toggle('active');
      this.body.classList.toggle('overflow-hidden');
      this.el.classList.toggle('active');
    });
  }

  bindEscape() {
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (this.el.classList.contains('active') && this.hamburgerIcon) {
        this.hamburgerIcon.classList.remove('active');
        this.body.classList.remove('overflow-hidden');
        this.el.classList.remove('active');
      }
    });
  }

  bindScrollDirection() {
    let oldValue = 0;
    let ticking = false;
    const update = () => {
      const newValue = window.pageYOffset;
      if (newValue < 5) {
        this.el.classList.remove('inactiveHeader', 'activeHeader');
      } else if (newValue < oldValue) {
        this.el.classList.add('activeHeader');
        this.el.classList.remove('inactiveHeader');
      } else if (newValue > oldValue) {
        this.el.classList.add('inactiveHeader');
        this.el.classList.remove('activeHeader');
      }
      oldValue = newValue;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
  }
}

Header.className = 'Header';
export default Header;
